import { createFileRoute } from "@tanstack/react-router";
import {
    kennelAdvertisingRoute,
    KennelAdvertisingPage,
} from "@/features/provider-home";

export const Route = createFileRoute("/kennel/_dashboard/advertising")({
    ssr: kennelAdvertisingRoute.ssr,
    head: kennelAdvertisingRoute.head,
    component: KennelAdvertisingPage,
});
